// === Card Detail Modal ===
//
// Clicking a card (grid or list) opens this overlay: a hero image header with
// the title over it, then the full details, a "move to another month"
// personalisation control, calendar/share tools, and a done toggle.

import store, { MONTH_OVERRIDES_KEY } from '../state/store.js';
import { escapeHtml } from '../utils/dom.js';
import { getHeroBackground } from '../utils/image.js';
import { getDetailsHtml, prepareResources } from '../utils/html-templates.js';
import { setItem } from '../services/storage-service.js';
import { MONTH_NAMES } from '../utils/date.js';
import { renderCards } from './card-renderer.js';
import { showToast } from '../utils/toast.js';
import { isDone, toggleDone } from '../services/completion-service.js';
import { pushScreen, back } from '../utils/nav.js';

let openId = null;

function els() {
  return {
    overlay: document.getElementById('cardModalOverlay'),
    hero: document.getElementById('cardModalHero'),
    badge: document.getElementById('cardModalBadge'),
    title: document.getElementById('cardModalTitle'),
    body: document.getElementById('cardModalBody')
  };
}

function completeBtnHtml(item) {
  const done = isDone(item.id);
  return `
    <button type="button"
      class="btn ${done ? 'btn-success' : 'btn-primary'} card-modal-complete"
      onclick="app.toggleFromModal('${escapeHtml(item.id)}')">
      ${done ? '✓ Completed' : 'Mark as complete'}
    </button>
  `;
}

function render(item) {
  const e = els();
  const done = isDone(item.id);

  e.hero.style.backgroundImage = getHeroBackground(item);
  e.hero.classList.toggle('is-done', done);
  e.badge.textContent = item.meta.category || '';
  e.title.textContent = item.content.title || '';

  const resourcesHtml = prepareResources(item);
  const taskList = item.tasks.map(t => `<li class="task-item">${escapeHtml(t.label)}</li>`).join('');

  e.body.innerHTML = `
    <p class="card-modal-summary">${escapeHtml(item.content.summary || '')}</p>
    ${completeBtnHtml(item)}
    ${getDetailsHtml(item, resourcesHtml, taskList)}
  `;
  e.body.scrollTop = 0;
}

export function openCardModal(id) {
  const item = store.seed.find(i => i.id === id);
  if (!item) return;
  openId = id;
  render(item);
  const { overlay, body } = els();
  overlay.removeAttribute('hidden');
  document.body.classList.add('search-open');
  // Always open scrolled to the very top (the element was display:none while
  // render() ran, so reset again now that it is visible).
  body.scrollTop = 0;
  requestAnimationFrame(() => { body.scrollTop = 0; });
  // Register with the back-stack so Back / Esc / overlay-click close the modal
  // (back to the grid) instead of leaving the app.
  pushScreen(close);
}

function close() {
  const { overlay } = els();
  if (overlay) overlay.setAttribute('hidden', '');
  document.body.classList.remove('search-open');
  openId = null;
}

// Re-render the open modal (after a state change like done/move).
function refresh() {
  if (!openId) return;
  const item = store.seed.find(i => i.id === openId);
  if (item) render(item);
}

export function setupCardModal() {
  const { overlay } = els();
  if (!overlay) return;
  const btnClose = document.getElementById('btnCloseCardModal');

  btnClose.addEventListener('click', back);
  overlay.addEventListener('click', (e) => {
    if (e.target === overlay) back();
  });
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && !overlay.hasAttribute('hidden')) back();
  });

  // window.app handlers used by the modal + cards
  window.app.openCard = openCardModal;

  window.app.toggleFromModal = (id) => {
    toggleDone(id);
    renderCards();
    refresh();
  };

  window.app.moveTaskMonth = (id, value) => {
    if (value === '' || value === null || value === undefined) {
      delete store.monthOverrides[id];
    } else {
      store.monthOverrides[id] = parseInt(value, 10);
    }
    setItem(MONTH_OVERRIDES_KEY, store.monthOverrides);
    renderCards();
    refresh();
    if (value === '') {
      showToast('Reset to default timing');
    } else {
      showToast(`Moved to ${MONTH_NAMES[parseInt(value, 10)]}`);
    }
  };
}
